export default __webpack_public_path__ + "static/media/gallery_18.6cc373b5.jpg";